import common from "../../utils/common";

/**
 * 车辆VIN变更记录
 */
class VehicleChange {
    /**
     * 变更类型 1.车架号变更 2.备用车架号变更
     */
    static TYPE_VIN = 1;
    static TYPE_SPARE_FRAME_NUMBER = 2;

    // 车辆用途
    static PURPOSE_PRIVATE = "1"
    static PURPOSE_PUBLIC = "2"

    static PurposeAlias = {
        [this.PURPOSE_PRIVATE]: "私车",
        [this.PURPOSE_PUBLIC]: "公车",
    }

    // 车辆类型
    static KIND_AUTOMATIC_CATCH = "automatic_catch";
    static KIND_MANUAL_GEAR = "manual_gear";
    static KIND_TIPTRONIC = "tiptronic";

    static KindsAlias = {
        [this.KIND_AUTOMATIC_CATCH]: "自动挡",
        [this.KIND_MANUAL_GEAR]: "手动挡",
        [this.KIND_TIPTRONIC]: "手自一体",
    }

    // 状态：1.启用 2.禁用
    static STATUS_ENABLE = 1
    static STATUS_DISABLE = 2

    static StatusAlias = {
        [this.STATUS_DISABLE]: '禁用',
        [this.STATUS_ENABLE]: '启用',
    }

    // 车辆来源 1.新车客户 2.维修客户 3.租赁客户 4.增值业务客户 5.二手车客户
    static CUSTOMER_TYPE_SALE = 1;
    static CUSTOMER_TYPE_SUPPORT = 2;
    static CUSTOMER_TYPE_RENT = 3;
    static CUSTOMER_TYPE_VAS = 4;
    static CUSTOMER_TYPE_ASSISTANT = 5;

    static CustomerTypeAlias = {
        [this.CUSTOMER_TYPE_SALE]: '新车客户',
        [this.CUSTOMER_TYPE_SUPPORT]: '维修客户',
        [this.CUSTOMER_TYPE_RENT]: '租赁客户',
        [this.CUSTOMER_TYPE_VAS]: '增值业务客户',
        [this.CUSTOMER_TYPE_ASSISTANT]: '二手车客户',
    }
}

class Project {
    static TYPE_PROJECT = "project";
    static TYPE_OUTSOURCE = "outsource";
}

export {
    Project,
    VehicleChange
}